import React, {useRef} from 'react';
import {
  Grid,
  Table,
  Button,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  Box,
  Tooltip
} from '@material-ui/core';
import PropTypes from 'prop-types';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {makeStyles} from '@material-ui/styles';
import {
  ArrowHeaderTable as ArrowHeaderTableIcon,
} from '../../../../../icons/index';
import {useHistory} from 'react-router-dom';
import Skeleton from "@material-ui/lab/Skeleton";
import {
  VisibleContent,
  CustomCheckbox,
  CustomTablePagination,
  CustomMoment as Moment,
} from "../../../../../components";
import clsx from "clsx";
import payloadTitles from "./payloadTitles.json";

import userRoles from "../../../../../constant/userRoles";
import moment from "moment";
import {typesOptions} from "../Filter/Filter";

const useStyles = makeStyles(theme => ({
  form: {
    marginBottom: 30
  },
  gridLines: {
    alignItems: 'flex-end'
  },

  tableSortLabel: {
    '& .MuiTableSortLabel-icon': {
      opacity: 0.5
    }
  },
  tableCellAction: {
    display: 'flex',
    alignItems: 'center'
  },
  tableRow: {
    '& td': {
      padding: '10px!important'
    }
  },

  bulkOperations: {
    position: 'relative'
  },
  bulkActions: {
    paddingLeft: 4,
    paddingRight: 4,
    marginTop: 6,
    position: 'absolute',
    width: '100%',
    zIndex: 2,
    backgroundColor: '#fafafa'
  },
  bulkAction: {
    marginLeft: theme.spacing(2)
  },

  image: {
    width: 65,
    height: 65,
    marginBottom: -10,

    position: 'relative',
    zIndex: 555
  },

  stickyActionsColumn: {
    '& table:first-child': {
      '& tr': {
        '&:hover td:last-child': {
          backgroundColor: theme.palette.background.default,
        },
        '& td:last-child, th:last-child': {
          backgroundColor: 'white',
          position: 'sticky',
          right: 0,
          zIndex: 999
        },
        '& th:last-child': {
          backgroundColor: 'rgb(237, 241, 246)',
        },
        '& th:first-child': {
          zIndex: 9999
        }
      }
    }
  },

  cellPayload: {
    maxWidth: 500
  },
  ceilColor: {
    width: 20,
    height: 45,
    borderRadius: 2
  },

  rowPayloadItem: {
    fontSize: 14,
    lineHeight: 1.2,
    color: "#152435",
    "& span": {
      opacity: 0.6
    }
  },
  buttonPayloadMore: {
    marginTop: 4,
    height: 20,
    borderRadius: 4,
    fontSize: 12,
    lineHeight: "14px",
    color: "white"
  }
}));

const RowLoading = () => {
  return (
    <>
      {
        [0, 1, 2, 3, 4, 5, 6, 7].map((item) => (
          <TableRow idx={`table-loading-row-${ item }`} className={'MuiTableRow-list'}>
            <TableCell><Skeleton height={40}/></TableCell>
            <TableCell><Skeleton height={40}/></TableCell>
            <TableCell><Skeleton height={40}/></TableCell>
            <TableCell><Skeleton height={40}/></TableCell>
            <TableCell><Skeleton height={40}/></TableCell>
          </TableRow>
        ))
      }
    </>
  )
}
const TableComponents = props => {
  const {
    rows,
    columns,
    showColumns,
    isChangeRowPage,
    isLoading,
    filter,
    isChangeFilter,

    onOpenModalInformation
  } = props;
  let {pagination} = props;
  const classes = useStyles();
  const refTable = useRef(null);
  const history = useHistory();

  const handleChangeRowPage = (event) => {
    pagination.rowsPerPage = event.target.value;

    isChangeRowPage(pagination)
  }
  const handleChangePage = (event, page) => {
    let newFilter = filter;
    newFilter['page'] = page;

    isChangeFilter(newFilter);
  }
  const createSortHandler = (field) => {
    const isAsc = pagination.orderBy === field && pagination.order === 'asc';
    pagination.order = isAsc ? 'desc' : 'asc';
    pagination.orderBy = field;

    isChangeRowPage(pagination);
  }

  const handleOpenInformation = (row) => {
    onOpenModalInformation(row)
  }

  return (
    <>
      <CustomTablePagination
        rows={rows}
        filter={filter}
        pagination={pagination}
        onChangePage={(event, page) => handleChangePage(event, page + 1)}
        onChangeRowsPerPage={handleChangeRowPage}
      />

      <PerfectScrollbar style={{ height: 'auto' }}>
        <Box>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Дата</TableCell>
                <TableCell width={220}>Тип операции</TableCell>
                <TableCell>Действия</TableCell>
                <TableCell>ГРЗ</TableCell>
                <TableCell>Пользователь</TableCell>
                <TableCell align="right">IP</TableCell>
                <TableCell width={64} align="center">RU IP</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <VisibleContent visible={!isLoading}>
                {rows.map((item) => (
                  <RowItem
                    key={`RowItem-${ item.created }`}
                    item={item}
                  />
                ))}
              </VisibleContent>
              <VisibleContent visible={isLoading}>
                <RowsLoading/>
              </VisibleContent>
            </TableBody>
          </Table>
        </Box>
      </PerfectScrollbar>

      <CustomTablePagination
        rows={rows}
        filter={filter}
        pagination={pagination}
        onChangePage={(event, page) => handleChangePage(event, page + 1)}
        onChangeRowsPerPage={handleChangeRowPage}
      />
    </>
  );
};
const RowItem = ({ item }) => {
  const classes = useStyles();
  const [typeOption] = React.useState(() => {
    return typesOptions.find((t) => Boolean(String(t.value) === String(item?.type)));
  });
  const [grzList] = React.useState(() => {
    let _payload = item?.payload || [];
    if (typeof _payload !== "object") {
      _payload = [];
    }
    const payloadLicensePlateList = (_payload || []).find((t) => t.Key === 'license_plate_list')?.Value || [];
    return (item?.license_plate_list || payloadLicensePlateList || []).join(', ')
  });
  const [payloadItems] = React.useState(() => {
    let _list = [];
    let _payload = item?.payload || [];
    if (typeof _payload !== "object") {
      _payload = [];
    }
    (_payload || []).filter((t) => !!t.Value).map((item) => {
      let value = item?.Value;
      if (disabledPayloadKeys.includes(item?.Key)) {
        value = ""
      }
      if (disabledPayloadValues.includes(value)) {
        value = "";
      }
      if (['roles'].includes(item?.Key)) {
        value = [...(value || [])].map((t) => t.Key).map((t) => (userRoles?.[t] || 'Н/Д')).join(', ')
      }
      if (['status'].includes(item?.Key)) {
        value = Boolean(value) ? 'Активно' : 'Неактивно'
      }
      if (['datetime_start', 'datetime_end', 'datetime', 'created', 'created_start', 'created_end'].includes(item?.Key) && value) {
        value = moment(value).format('DD.MM.YYYY HH:mm:ss')
      }

      const typeItem = typeof value;
      if (['object'].includes(typeItem)) {
        value = Object.keys(value).length > 0 ? JSON.stringify(value) : "";
      }
      if (!!value) {
        _list.push({
          key: item.Key,
          title: payloadTitles?.[item.Key],
          value: value
        })
      }
    });

    if (item.type === "logCreateExportJob") {
      const payloadType = _payload.find((t) => t.Key === 'type')?.Value;
      let _type = '';
      if (payloadType.includes('pdf')) {
        _type = "PDF"
      }
      if (payloadType.includes('csv')) {
        _type = "CSV"
      }

      _list.unshift(...[
        {
          key: 'license_plate_count',
          title: 'Кол-во ГРЗ в выгрузке',
          value: item?.license_plate_count || 0
        },
        {
          key: '_type_',
          title: 'Формат выгрузки',
          value: _type
        },
      ])
    }

    return _list
  });
  const [isOpenPayload, setOpenPayload] = React.useState(false);
  return (
    <TableRow>
      <TableCell>
        <div dangerouslySetInnerHTML={{ __html: moment(item?.created).format('DD.MM.YYYY<br/>HH:mm:ss') }}/>
      </TableCell>
      <TableCell>
        { typeOption?.title || item?.type || "Н/Д" }
      </TableCell>
      <TableCell>
        <Grid container spacing={0.5} direction="column" style={{maxWidth: 640}}>
          {payloadItems.map((payloadItem, index) => {
            if (!isOpenPayload && index > 2) return
            return (
              <Grid key={`payloadItem-${ payloadItem?.key }`} item>
                <div className={classes.rowPayloadItem}>
                  <span>{payloadItem?.title || payloadItem?.key}</span>: {payloadItem?.value}
                </div>
              </Grid>
            )
          })}
          {Boolean(payloadItems.length > 2) && (
            <Grid item>
              <Button
                variant="contained"
                onClick={() => setOpenPayload(!isOpenPayload)}
                className={classes.buttonPayloadMore}
              >{isOpenPayload ? 'Свернуть' : 'Развернуть'}</Button>
            </Grid>
          )}
        </Grid>
      </TableCell>
      <TableCell>{ grzList || "Н/Д" }</TableCell>
      <TableCell>{ item?.username || 'Н/Д' }</TableCell>
      <TableCell align="right">{ item?.ip || 'Н/Д' }</TableCell>
      <TableCell align="center">
        <CustomCheckbox checked={item.ip_ru}/>
      </TableCell>
    </TableRow>
  )
};
const RowsLoading = () => {
  return new Array(10).fill(10).map((t, i) => (
    <TableRow>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
      <TableCell><Skeleton/></TableCell>
    </TableRow>
  ))
}

TableComponents.propTypes = {
  columns: PropTypes.array,
  showColumns: PropTypes.array,
  rows: PropTypes.array,
  selected: PropTypes.array,
  pagination: PropTypes.object,
  isSelectRowTable: PropTypes.func,
  isDeleteRowTable: PropTypes.func,
  isChangeRowPage: PropTypes.func,
};
TableComponents.defaultProps = {
  showColumns: []
};

const disabledPayloadKeys = [
  'type',
  'limit',
  'user_id',
  'password',
  'sort_field',
  'created_end',
  'datetime_end',
  'created_start',
  'otp_generated',
  'datetime_start',
  'sort_direction',
  'license_plate_list',
  'report_overlay_request'
];
const disabledPayloadValues = [
  '0001-01-01T02:30:17+02:30',
  '0001-01-01T00:00:00Z',
  '000000000000000000000000'
];

export default TableComponents;
